import config from "../config";
import { authFetch } from "./Security/authFetch";


export function formatDuration(
  duration: string | number | null | undefined,
): string {
  if (duration == null) return "";

  // Handle nanoseconds (Telebras endpoint)
  if (typeof duration === "number") {
    const totalMinutes = Math.floor(duration / 1_000_000_000 / 60);
    return `${totalMinutes}m`;
  }

  const str = String(duration).trim();

  // Handle numeric strings (e.g. "50000000000")
  if (/^-?\d+$/.test(str)) {
    const ns = Number(str);
    const totalMinutes = Math.floor(ns / 1_000_000_000 / 60);
    return `${totalMinutes}m`;
  }

  // Handle ISO-8601 durations (e.g. PT-2M-19S)
  const regex = /PT(?:(-?\d+)H)?(?:(-?\d+)M)?(?:(-?\d+)S)?/;
  const match = str.match(regex);

  if (!match) return str;

  const hours = parseInt(match[1] || "0", 10);
  const minutes = parseInt(match[2] || "0", 10);
  const seconds = parseInt(match[3] || "0", 10);

  const totalSeconds = hours * 3600 + minutes * 60 + seconds;
  const absSeconds = Math.abs(totalSeconds);
  const totalMinutes = Math.floor(absSeconds / 60);

  return totalSeconds < 0 ? `-${totalMinutes}m` : `${totalMinutes}m`;
}
/**
 * Converts a duration (number in ns/µs/ms or ISO string like "PT5M") to minutes
 */
export function durationInMinutes(
  value: number | string | null | undefined
): number {
  if (value == null) return 0;

  let ms: number;

  if (typeof value === "number") {
    // Detect nanoseconds (very large)
    if (value > 1e12) ms = value / 1e6; // ns → ms
    else if (value > 1e9) ms = value / 1e3; // µs → ms
    else ms = value; // already ms
  } else if (typeof value === "string") {
    // Try to parse ISO 8601 duration (e.g., "PT5M30S")
    const regex = /PT(?:(\d+)H)?(?:(\d+)M)?(?:(\d+)S)?/;
    const match = value.match(regex);
    if (!match) return 0;

    const hours = parseInt(match[1] || "0", 10);
    const minutes = parseInt(match[2] || "0", 10);
    const seconds = parseInt(match[3] || "0", 10);

    ms = hours * 3600 * 1000 + minutes * 60 * 1000 + seconds * 1000;
  } else {
    return 0;
  }

  return Math.floor(ms / 1000 / 60); // ms → minutes
}
export async function getFullNameByUsername(username: string): Promise<string> {
  try {
    if (!username) return "";

    const sanitizedUsername = username.replace(/\\/g, "/");
    const encodedUsername = encodeURIComponent(username);
    const response = await authFetch(
      `${config.apiBaseUrl}/api/users/fullname?username=${encodedUsername}`
    );
    if (!response.ok) return username;
    const fullName = await response.text();
    return fullName || username;
  } catch (error) {
    console.error("Error fetching full name:", error);
    return username;
  }
}
